<template>
  <div id="app">
    <div class="menu-box" v-if="screenWidth > 750">
      <div class="log-box">
        <img src="@/assets/logo.png" alt="">
      </div>
      <div class="menu-item">
        <div @click="choiceMenu(1)" :class="(menuIndex === 1) ? 'choice' : ''">HOME</div>
        <div @click="choiceMenu(2)" :class="(menuIndex === 2) ? 'choice' : ''">Our Products</div>
        <div @click="choiceMenu(3)" :class="(menuIndex === 3) ? 'choice' : ''">Company advantage</div>
        <div @click="choiceMenu(4)" :class="(menuIndex === 4) ? 'choice' : ''">Contact us</div>
      </div>
    </div>
    <div id='step_1' ref="step_1"></div>
    <div class="banner-box">
      <img src="../assets/banner.png" class="banner">
      <div class="app-name">
        <div class="title">Shijie Voice Technology co. LTD.</div>
        <div class="content">
          Shijie Voice Technology co. LTD. is a local start-up company headquartered in Bangladesh. The company's main business is the development of efficiency tools and efficiency improvement solutions to help users better plan and manage personal time, work efficiency and project progress. It aims to help Improve efficiency, release productivity, and enjoy Internet resources equally.
        </div>
      </div>
    </div>

    <div id='step_2' ref="step_2"></div>
    <div class="our_products">
      <div class="title">Our Products</div>
      <div class="products-box">
        <div class="img-box">
          <a href="https://play.google.com/store/apps/details?id=com.ocl.oclockview"><img src="../assets/list-2.png" /></a>
          <div class="text-1">OclockView</div>
        </div>
        <div class="img-box">
          <img src="../assets/list-1.png" />
          <div class="text-1">BubbleLayout</div>
        </div>
      </div>
    </div>

    <div id='step_3' ref="step_3"></div>
    <div class="advantage">
      <div class="title">Company advantage</div>
      <div class="text-box">
        <img src="../assets/fanggou.png" alt="">
        <div>Specialized expertise: We specialize in developing and providing efficiency tools, leveraging the knowledge of our experienced professionals. With a deep understanding of user needs and industry trends, we offer practical and effective solutions.</div>
      </div>
      <div class="text-box">
        <img src="../assets/fanggou.png" alt="">
        <div> Technological innovation: We are dedicated to continuous technological innovation, regularly introducing new features and tools to enhance user efficiency. By staying abreast of the latest technological advancements, we incorporate them into our product development, delivering an improved user experience.</div>
      </div>
      <div class="text-box">
        <img src="../assets/fanggou.png" alt="">
        <div> Customized solutions: We work closely with our users to offer personalized solutions tailored to their workflows and preferences. This approach helps them effectively plan and manage their work according to their specific requirements.</div>
      </div>
      <div class="text-box">
        <img src="../assets/fanggou.png" alt="">
        <div> Exceptional support and service: Our commitment to providing high-quality support and service sets us apart. Our dedicated customer support team promptly addresses user queries and issues, ensuring seamless utilization of the tool's functionalities.</div>
      </div>
    </div>

    <div id='step_4' ref="step_4"></div>
    <div class="contact">
      <div class="title">Contact us</div>
      <div class="contact-box">
        <img src="../assets/us.png" class="us">
        <div class="text-box">
          <p>If you are interested in our company and have cooperation intentions, please contact our business team email or come to our office directly to negotiate. Looking forward to your attention and support, thank you for your trust.</p>
          <div class="elem">
            <img src="../assets/list-3.png" alt="">
            <span>support@shijietech.com</span>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright">Copyright © Shijie Voice Technology co. LTD. All Rights Reserved.</div>

  </div>
</template>

<script>
import privacy from "@/components/privacy";
export default {
  name: 'App',
  components: {
    privacy
  },
  data() {
    return {
      isMore: false,
      menuIndex: 0,
      screenWidth: document.body.clientWidth,
      showMenu: false
    }
  },
  mounted() {
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
  },
  methods: {
    choiceMenu(index) {
      this.menuIndex = index
      setTimeout(() => {
        this.showMenu = false
      }, 100);
      switch (index) {
        case 1: document.getElementById("step_1").scrollIntoView(); break;
        case 2: document.getElementById("step_2").scrollIntoView(); break;
        case 3: document.getElementById("step_3").scrollIntoView(); break;
        case 4: document.getElementById("step_4").scrollIntoView(); break;
        case 5: document.getElementById("step_5").scrollIntoView(); break;
        case 6: document.getElementById("step_6").scrollIntoView(); break;
        case 7: document.getElementById("step_7").scrollIntoView(); break;
        case 8: document.getElementById("step_8").scrollIntoView(); break;
        case 9: document.getElementById("step_9").scrollIntoView(); break;
        case 10: document.getElementById("step_10").scrollIntoView(); break;
        default:
          break;
      }
    },
    menuClick() {
      this.showMenu = !this.showMenu
    }
  }
}
</script>


<style lang="less" >
@import url('@/style/m_index.less') only screen and (max-width: 750px);
@import url('@/style/pc_index.less') only screen and (min-width: 750px);
</style>
